import initialState from './../../initialState';

export default (
  state = initialState.calendarioPresenca,
  { type, value, response }
) => {
  switch (type) {
    case 'LIST_CALENDARIO_PRESENCA_REQUEST':
      return {
        ...state,
        fetching: 1
      };
    case 'LIST_CALENDARIO_PRESENCA_FAILURE':
      return {
        ...state,
        fetching: 0,
        errors: ['Falha na obtenção da lista para o calendário']
      };
    case 'LIST_CALENDARIO_PRESENCA_SUCCESS':
      return {
        ...state,
        fetching: 2,
        errors: [],
        result: response
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/calendarioPresenca/reducer.js